<mat-toolbar class="top-navbar-toolbar">
  <mat-toolbar-row>
    <div class="navbar-grid">
      <!-- LEFT ZONE: Branding/Navigation -->
      <div class="navbar-zone navbar-zone--branding">
        <button mat-fab class="abook-fab --round --transparent" (click)="toggleMainMenu()" aria-label="Toggle menu">
          <mat-icon>menu</mat-icon>
        </button>

        @if (routeHasFocusMode()) {
          <button
            mat-fab
            class="abook-fab --round --transparent"
            (click)="togglePageFocusMode()"
            aria-label="skift fokus tilstand"
            [matTooltip]="isFocusModeEnabled() ? 'Deaktivér fokustilstand' : 'Aktivér fokustilstand'"
          >
            <mat-icon>{{ isFocusModeEnabled() ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
          </button>
        }
      </div>

      <!-- CENTER ZONE: Contextual info -->
      <div class="navbar-zone navbar-zone--center"></div>

      <!-- RIGHT ZONE: User actions -->
      <div class="navbar-zone navbar-zone--actions">
        @if (helpArticle(); as article) {
          <a
            mat-fab
            class="abook-fab --round --transparent"
            [routerLink]="'/help/' + article"
            matTooltip="Hjælp til denne side"
            aria-label="Hjælp til denne side"
          >
            <mat-icon>help_outline</mat-icon>
          </a>
        }
        <div class="user-menu-container">
          <span class="user-name" [matMenuTriggerFor]="userMenu">
            {{ userOrAssociationName() }}
          </span>
          <button
            class="abook-fab --round --primary --small-text"
            mat-fab
            [matMenuTriggerFor]="userMenu"
            aria-label="Vis bruger menu"
          >
            {{ loggedUser()?.initial ? loggedUser()?.initial : '' }}
          </button>
          <mat-menu #userMenu="matMenu">
            @if (loggedUser()) {
              <a mat-menu-item [routerLink]="['/profile']">
                <mat-icon>person</mat-icon>
                <span>Min profil</span>
              </a>
            }
            @if (isAssociationLogin()) {
              <button mat-menu-item [routerLink]="['/associations/select-association']">
                <mat-icon>holiday_village</mat-icon>
                <span>Skift forening</span>
              </button>
            }
            @if (!loggedUser()) {
              <button mat-menu-item (click)="signIn()">
                <mat-icon>login</mat-icon>
                <span>Log ind</span>
              </button>
            } @else {
              <button mat-menu-item (click)="signOut()">
                <mat-icon>logout</mat-icon>
                <span>Log ud</span>
              </button>
            }
          </mat-menu>
        </div>

        @if (isAssociationLogin() && showBasketIcon()) {
          <button
            mat-fab
            class="abook-fab --round --white --small-text"
            [matBadge]="basketStore.itemsCount()"
            [matBadgeHidden]="basketStore.itemsCount() === 0"
            (click)="toggleBasket()"
            aria-label="Vis kurven"
          >
            <mat-icon>shopping_cart</mat-icon>
          </button>
        }
      </div>
    </div>

    @if (!env.production) {
      <span class="environment-chip">Env: {{ env.env }}</span>
    }
  </mat-toolbar-row>
</mat-toolbar>
